module.exports = __webpack_public_path__ + "img/masseuse.cfba4e06.png";